var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-map-genes-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-map-genes-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-map-genes-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-map-genes-head" }, [
                _c("div", { staticClass: "wkb-map-genes-head-row" }, [
                  _c("h2", { attrs: { id: "wkb-map-genes-title" } }, [
                    _vm._v("Map genes"),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "wkb-map-genes-close",
                      attrs: {
                        type: "button",
                        "aria-label": "Close",
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  ),
                ]),
                _c("p", { staticClass: "wkb-map-genes-intro" }, [
                  _vm._v(
                    " Genes that appear in more than two of the selected gene sets, sorted by how many sets they cross. Click a gene to add it to the graph. "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "wkb-map-genes-body" },
                [
                  _vm.loading
                    ? _c(
                        "p",
                        {
                          staticClass: "wkb-map-genes-status",
                          attrs: { role: "status" },
                        },
                        [
                          _vm._v(
                            " Loading gene lists for " +
                              _vm._s(_vm.selectedGeneSetCount) +
                              " selected gene set" +
                              _vm._s(
                                _vm.selectedGeneSetCount === 1 ? "" : "s"
                              ) +
                              "… "
                          ),
                        ]
                      )
                    : _vm.error
                    ? _c(
                        "p",
                        {
                          staticClass: "wkb-map-genes-error",
                          attrs: { role: "alert" },
                        },
                        [_vm._v(" " + _vm._s(_vm.error) + " ")]
                      )
                    : [
                        !_vm.selectedGeneSetCount
                          ? _c("p", { staticClass: "wkb-map-genes-empty" }, [
                              _vm._v(
                                " Mark gene sets as selected on the canvas before mapping genes. "
                              ),
                            ])
                          : [
                              _c("p", { staticClass: "wkb-map-genes-helper" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedGeneSetCount) +
                                    " selected gene set" +
                                    _vm._s(
                                      _vm.selectedGeneSetCount === 1 ? "" : "s"
                                    ) +
                                    " · " +
                                    _vm._s(_vm.rows.length) +
                                    " shared gene" +
                                    _vm._s(_vm.rows.length === 1 ? "" : "s") +
                                    " "
                                ),
                              ]),
                              _vm.skippedGeneSets.length
                                ? _c(
                                    "ul",
                                    { staticClass: "wkb-map-genes-skipped" },
                                    _vm._l(
                                      _vm.skippedGeneSets,
                                      function (entry) {
                                        return _c("li", { key: entry.id }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(entry.label) +
                                              ": " +
                                              _vm._s(entry.reason) +
                                              " "
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.rows.length
                                ? _c(
                                    "div",
                                    { staticClass: "wkb-map-genes-table-wrap" },
                                    [
                                      _c(
                                        "table",
                                        { staticClass: "wkb-map-genes-table" },
                                        [
                                          _c("thead", [
                                            _c(
                                              "tr",
                                              [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass:
                                                      "wkb-map-genes-col-gene",
                                                    attrs: { scope: "col" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Gene (click to add) "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass:
                                                      "wkb-map-genes-col-count",
                                                    attrs: { scope: "col" },
                                                  },
                                                  [_vm._v("# Sets")]
                                                ),
                                                _vm._l(
                                                  _vm.columns,
                                                  function (column) {
                                                    return _c(
                                                      "th",
                                                      {
                                                        key: column.id,
                                                        staticClass:
                                                          "wkb-map-genes-col-set wkb-map-genes-col-set-header",
                                                        attrs: { scope: "col" },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "wkb-map-genes-set-label",
                                                          },
                                                          _vm._l(
                                                            _vm.geneSetLabelLines(
                                                              column.label
                                                            ),
                                                            function (
                                                              line,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key: `${column.id}-${index}`,
                                                                  staticClass:
                                                                    "wkb-map-genes-set-label-line",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        line
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(_vm.rows, function (row) {
                                              return _c(
                                                "tr",
                                                { key: row.row_id },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "wkb-map-genes-col-gene",
                                                      attrs: { scope: "row" },
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "wkb-map-genes-gene-btn",
                                                          class: {
                                                            "is-on-graph":
                                                              _vm.isGeneOnGraph(
                                                                row.gene
                                                              ),
                                                            "is-busy":
                                                              _vm.addingGene ===
                                                              row.gene,
                                                          },
                                                          attrs: {
                                                            type: "button",
                                                            disabled:
                                                              _vm.addingGene ===
                                                                row.gene ||
                                                              _vm.isGeneOnGraph(
                                                                row.gene
                                                              ),
                                                            title:
                                                              _vm.geneButtonTitle(
                                                                row.gene
                                                              ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.$emit(
                                                                "add-gene",
                                                                row.gene
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(row.gene) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "wkb-map-genes-col-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.gene_set_count
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.columns,
                                                    function (column) {
                                                      return _c(
                                                        "td",
                                                        {
                                                          key: column.id,
                                                          staticClass:
                                                            "wkb-map-genes-col-set",
                                                        },
                                                        [
                                                          row[column.id]
                                                            ? _c("b-icon", {
                                                                staticClass:
                                                                  "wkb-map-genes-check",
                                                                attrs: {
                                                                  icon: "check-circle-fill",
                                                                  "aria-hidden":
                                                                    "true",
                                                                },
                                                              })
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "wkb-map-genes-empty-cell",
                                                                },
                                                                [_vm._v("—")]
                                                              ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "p",
                                    { staticClass: "wkb-map-genes-empty" },
                                    [
                                      _vm._v(
                                        " No genes appear in more than two of the loaded gene sets. Select more gene sets or choose sets with more overlap. "
                                      ),
                                    ]
                                  ),
                            ],
                      ],
                ],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }